// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Vod } from '../../types/Model';

export interface VodListRequestPayload {
  keyword: string;
  page: number;
  limit: number;
}

export interface VodListSuccessPayload {
  listData: Vod[];
  totalPage: number;
}

export interface VodListFailPayload {
  error: Error;
}

export const getVodListActions = createAsyncAction(
  'elearning/GET_VOD_LIST',
  'elearning/GET_VOD_LIST_SUCCESS',
  'elearning/GET_VOD_LIST_FAIL'
)<VodListRequestPayload, VodListSuccessPayload, VodListFailPayload>();
